import { combineReducers } from "redux";

import {
  AdminNotesList,
  AllPatientIntakeTabList,
  AllPatientRecordList,
  AppConfigsReducer,
  AssignStaffIncompleteRequest,
  AuthFollowingPhysicianDetails,
  AuthOrderingPhysicianDetails,
  AuthorizationDetailTabs,
  AuthorizationHistory,
  AuthorizationStatus,
  CareCordinationProgram,
  CheckEligibility,
  ClinicalGroupingReducer,
  DeactivateNotesTemplate,
  DeleteAdminNotesTemplate,
  DischargeReason,
  Discipline,
  DisciplineRequestorReducer,
  DisciplineTemplate,
  DisciplineType,
  DiseaseType,
  DocumentCreatedBy,
  DocumentDownload,
  DocumentReview,
  DocumentSource,
  DocumentType,
  EligibilityHistoryReducer,
  EligibilityRecord,
  ExcelDownload,
  FollowingPhysicianDetails,
  HealthProgram,
  Icd10Records,
  IcdCodeType,
  IncompleteRequestPatient,
  InformationReceivedResponse,
  LoggedInUser,
  MyPatientList,
  NonCoveredServices,
  OrderAcceptor,
  OrderingSource,
  PatientInformationView,
  PatientInforReceived,
  PatientPhotoUpdate,
  PatientReferralInfoResponse,
  PatientReferralRequest,
  PatientStateReducer,
  PostServiceProvider,
  PostServiceRequest,
  PutAuthorizationDetailTab,
  PutMyPatientsList,
  ReauthCompleteReducer,
  ReauthDocumentReview,
  ReauthReferralIntakeRequest,
  ReauthReferralIntakeSubmit,
  ReAuthReview,
  ReAuthServiceRequest,
  ReAuthTimeline,
  ReceivedMethodResponse,
  ReferralDiscipline,
  ReferralServiceStatus,
  PriorAuthReferralSource,
  ReAuthReferralSource,
  ReferralSubmit,
  Relationship,
  RemovePatient,
  ResumeIntakeReducer,
  RoleReducer,
  SaveOrUpdateDocumentFile,
  SavePatientInformation,
  SaveReferralDocument,
  SaveUpdatePatientRequest,
  ServiceCareType,
  ServiceDisciplines,
  ServicePastMedicalHistory,
  ServiceProvider,
  ServiceProviderData,
  ServiceProviderDetails,
  ServicePsychologicalHistory,
  ServiceRequest,
  ServiceStatusReason,
  StaffingStatus,
  UpdateDiscipline,
  UrgencyStatus,
  UserDetails,
  UserList,
  UserModule,
  MasterNotesCategory,
  SaveNotes,
  UpdateNotes,
  GetNotesById,
  MasterNotesApprovalStatus,
  StaffingList,
  StaffingAssignStaff,
  StaffingUnassignStaff,
  DisciplineNoteReducer,
  DisciplineTemplateNotesReducer,
  GetDisciplineLevelNotesReducer,
  GetAuthDisciplineLevelNotesReducer,
  SaveDisciplineLevelNotesReducer,
  UpdateDisciplineLevelNotesReducer,
  ReferralNoteList,
  GetReferralLevelNotesReducer,
  SaveReferralLevelNotesReducer,
  UpdateReferralLevelNotesReducer,
  NotesTemplateJsonReducer,
  UserPermissionReducer,
  RemoveStaffingPatientReducer,
  RouteUrlInfoReducer,
  PermissionReducer,
  HealthPlanReducer,
  InitiateFaxSend,
  GenerateAuthTemplateReducer,
  BenefitPlanDetailsReducer,
  StoreFilterPayload,
  ServiceStatusReasonReducer,
  CountyReducer,
  UserListWithFilterReducer,
  MasterNtuReasonReducer,
  LanguageMasterReducer,
  AccomodationMasterReducer,
  UpdatePatientHeaderReducer,
  NotifyInternalDataValuesReducer,
  AgencyCommunicationReducer,
  AgencyCommunicationNoteReducer,
  LevelOfFunctionReducer,
  EligibilityDataReducer,
  DeleteServiceProviderReducer,
  AuthorizationTypeMasterReducer,
  FaxFormMasterReducer,
  FaxFormOptionMasterReducer,
  AllPendingUnassignStaff,
  ServiceRequestNumberMasterReducer,
  LetterCopyTypeMasterReducer,
  SaveAttachLetter,
  NppesDetailsDataReducer,
  ReferralManagementSystem,
  serviceRequestDisciplines,
  StoreFilterDataReducer,
  FacilityTypeMasterReducer,
  ReferralNoteUserListReducer,
  ResendFaxReducer,
  ResendEmailReducer,
  KeepNoteOpen,
  KeepNoteOpenUpdate,
  RationaleTemplateReducer,
  DownLoadNotesReducer,
  DownDisciplineLoadNotesReducer,
  DenialRationaleListReducer,
  RationaleManagementNameReducer,
  WoundCareDisciplineReducer,
  PutServiceProviderDetailsReducer,
  ApprovedVisitsReducer,
  PutRationaleTemplateReducer,
  PostRationaleTemplateReducer,
  DocumentNoteUserListReducer,
  ReferralTemplateNotesReducer,
  DisciplineNotesTemplateJsonReducer,
  UserModifiedReducer,
  MasterSyncReducer,
  PriorAuthReceivedMethodResponse,
  DocumentSourceForFilterReducer,
  NotesTemplateTypeReducer,
  BenefitPlanStateReducer,
  ValidatePatientSubscriberIdInfo,
  ValidatePatientMbiInfo,
  NppesOrderingDetailsListReducer,
  NppesPrimaryDetailsListReducer,
  EditableDisciplineNotesTemplateJson,
  MasterDisciplineTemplateNotesList,
  RelationshipTypeMasterReducer,
  ServiceRequestIsRetroReducer,
  MaxAllowedSocDateReducer,
  ServiceStatusMasterReducer,
  SendEmailReducer,
} from "../reducers";

import PayerReducer from "../reducers/PayerList";
import PhysicianRecordsReducer from "../reducers/PhysicianRecords";
import ReferralIntakePhysicianDetailsReducer from "../reducers/ReferralIntakePhysicianDetails";
import ReviewReducer from "../reducers/ReviewRequestList";
import ServiceProviderMasterReducer from "../reducers/ServiceProviderMaster";
import Survey from "../reducers/DisciplineSurvey";
import WoundCareReducer from "../reducers/WoundCare";
import DocumentTypeForPriorAuthReducer from "../reducers/DocumentTypeForPriorAuth";
import IntakeStageIdReducer from "../reducers/IntakeStageId";
import AppConfigsVariableReducer from "../reducers/AppConfigVariable";

const createRootReducer = combineReducers({
  allPatientIntakeTabState: AllPatientIntakeTabList,
  allPatientRecordState: AllPatientRecordList,
  appConfigsState: AppConfigsReducer,
  assignStaffIncompleteRequestState: AssignStaffIncompleteRequest,
  authFollowingPhysicianDetailsState: AuthFollowingPhysicianDetails,
  authOrderingPhysicianDetailsState: AuthOrderingPhysicianDetails,
  authorizationDetailTabsState: AuthorizationDetailTabs,
  authorizationhistoryState: AuthorizationHistory,
  authorizationStatusState: AuthorizationStatus,
  careCoordinationProgramState: CareCordinationProgram,
  careTypeState: ServiceCareType,
  checkEligibilityState: CheckEligibility,
  clinicalGroupState: ClinicalGroupingReducer,
  disaseTypeState: DiseaseType,
  dischargeReasonState: DischargeReason,
  disciplineRequestorState: DisciplineRequestorReducer,
  disciplinesState: ServiceDisciplines,
  disciplineState: Discipline,
  disciplineTemplateState: DisciplineTemplate,
  disciplineTypeState: DisciplineType,
  documentCreatedState: DocumentCreatedBy,
  documentDownloadState: DocumentDownload,
  documentReviewState: DocumentReview,
  documentSourceState: DocumentSource,
  documentTypeState: DocumentType,
  documentTypeForPriorAuthState: DocumentTypeForPriorAuthReducer,
  eligibilityHistoryState: EligibilityHistoryReducer,
  eligibilityRecordState: EligibilityRecord,
  excelDownloadState: ExcelDownload,
  followingPhysicianDetailsState: FollowingPhysicianDetails,
  healthProgramState: HealthProgram,
  icd10RecordState: Icd10Records,
  icdCodeTypeState: IcdCodeType,
  incompleteRequestState: IncompleteRequestPatient,
  informationReceivedState: InformationReceivedResponse,
  loggedInUserState: LoggedInUser,
  myPatientListState: MyPatientList,
  nonCoveredServiceState: NonCoveredServices,
  orderAcceptorState: OrderAcceptor,
  orderingSourceState: OrderingSource,
  pastMedicalHistoryState: ServicePastMedicalHistory,
  patientInformationReceivedState: PatientInforReceived,
  patientInformationViewState: PatientInformationView,
  intakeStageIdState: IntakeStageIdReducer,
  patientPhotoUpdateState: PatientPhotoUpdate,
  patientReferralInfoState: PatientReferralInfoResponse,
  patientReferralRequestState: PatientReferralRequest,
  patientServiceProviderMasterState: ServiceProviderMasterReducer,
  patientStateState: PatientStateReducer,
  payerState: PayerReducer,
  physicianRecordsState: PhysicianRecordsReducer,
  postServiceProviderState: PostServiceProvider,
  postServiceRequestState: PostServiceRequest,
  psychologicalHistoryState: ServicePsychologicalHistory,
  putAuthorizationDetailTabState: PutAuthorizationDetailTab,
  putMyPatientListState: PutMyPatientsList,
  ReauthCompleteState: ReauthCompleteReducer,
  reAuthDocumentReviewState: ReauthDocumentReview,
  reauthReferralIntakeRequestState: ReauthReferralIntakeRequest,
  reAuthReviewState: ReAuthReview,
  reAuthServiceRequestState: ReAuthServiceRequest,
  reAuthSubmitState: ReauthReferralIntakeSubmit,
  reAuthTimelineState: ReAuthTimeline,
  receivedMethodState: ReceivedMethodResponse,
  referralDisciplineState: ReferralDiscipline,
  referralDocumentState: SaveReferralDocument,
  referralIntakePhysicianDetailsState: ReferralIntakePhysicianDetailsReducer,
  referralServiceStatusState: ReferralServiceStatus,
  priorAuthReferralSourceState: PriorAuthReferralSource,
  reAuthReferralSourceState: ReAuthReferralSource,
  referralSubmitState: ReferralSubmit,
  relationshipState: Relationship,
  RemovePatientState: RemovePatient,
  ResumeIntakeState: ResumeIntakeReducer,
  reviewState: ReviewReducer,
  RoleState: RoleReducer,
  saveDocumentFileState: SaveOrUpdateDocumentFile,
  SavePatientInformationState: SavePatientInformation,
  saveUpdatePatientRequestState: SaveUpdatePatientRequest,
  serviceProviderDataState: ServiceProviderData,
  serviceProviderDetailsState: ServiceProviderDetails,
  serviceProviderState: ServiceProvider,
  serviceRequestState: ServiceRequest,
  serviceStatusReasonState: ServiceStatusReason,
  staffingStatusState: StaffingStatus,
  updateDisciplineState: UpdateDiscipline,
  urgencyStatusState: UrgencyStatus,
  userDetailsState: UserDetails,
  userListState: UserList,
  userModuleState: UserModule,
  serveyDetailsUpdate: Survey,
  adminNotesListState: AdminNotesList,
  notesApprovalStatusState: MasterNotesApprovalStatus,
  deactivateNotesTemplateState: DeactivateNotesTemplate,
  deleteAdminNotesTemplateState: DeleteAdminNotesTemplate,
  adminCategoryNotesMasterState: MasterNotesCategory,
  saveAdminNotesState: SaveNotes,
  GetadminNotesState: GetNotesById,
  updateAdminNotesState: UpdateNotes,
  staffingListState: StaffingList,
  staffingAssignStaffState: StaffingAssignStaff,
  staffingUnassignStaffState: StaffingUnassignStaff,
  disciplineNoteListState: DisciplineNoteReducer,
  disciplineTemplateNotesState: DisciplineTemplateNotesReducer,
  disciplineTemplateNotesListState: MasterDisciplineTemplateNotesList,
  referralTemplateNotesState: ReferralTemplateNotesReducer,
  GetDisciplineLevelNotesState: GetDisciplineLevelNotesReducer,
  GetAuthDisciplineLevelNotesState: GetAuthDisciplineLevelNotesReducer,
  SaveDisciplineLevelNotesState: SaveDisciplineLevelNotesReducer,
  UpdateDisciplineLevelNotesState: UpdateDisciplineLevelNotesReducer,
  referralNotesListState: ReferralNoteList,
  GetReferralLevelNotesState: GetReferralLevelNotesReducer,
  SaveReferralLevelNotesState: SaveReferralLevelNotesReducer,
  UpdateReferralLevelNotesState: UpdateReferralLevelNotesReducer,
  NotesTemplateJsonState: NotesTemplateJsonReducer,
  DisciplineNotesTemplateState: DisciplineNotesTemplateJsonReducer,
  editableDisciplineNotesTemplateState: EditableDisciplineNotesTemplateJson,
  UserPermissionState: UserPermissionReducer,
  RemoveStaffingPatientState: RemoveStaffingPatientReducer,
  RouteUrlInfoState: RouteUrlInfoReducer,
  permissionState: PermissionReducer,
  healthPlanMasterState: HealthPlanReducer,
  postFaxSendingState: InitiateFaxSend,
  generateAuthTemplateState: GenerateAuthTemplateReducer,
  benefitPlanDetailsState: BenefitPlanDetailsReducer,
  benefitPlanStates: BenefitPlanStateReducer,
  filterState: StoreFilterPayload,
  serviceStatusReasonMasterState: ServiceStatusReasonReducer,
  countyState: CountyReducer,
  userListWithFilterState: UserListWithFilterReducer,
  masterNtuReasonState: MasterNtuReasonReducer,
  languageState: LanguageMasterReducer,
  accomodationState: AccomodationMasterReducer,
  updatePatientHeaderState: UpdatePatientHeaderReducer,
  NotifyInternalDataValuesState: NotifyInternalDataValuesReducer,
  masterAgencyCommunicationState: AgencyCommunicationReducer,
  agencyCommunicationNote: AgencyCommunicationNoteReducer,
  levelOfFunctionState: LevelOfFunctionReducer,
  eligibilityData: EligibilityDataReducer,
  deleteServiceProviderState: DeleteServiceProviderReducer,
  MasterAuthorizationTypeState: AuthorizationTypeMasterReducer,
  masterFaxFormState: FaxFormMasterReducer,
  masterFaxFormOptionState: FaxFormOptionMasterReducer,
  allPendingUnassignStaffState: AllPendingUnassignStaff,
  letterCopyTypeMasterState: LetterCopyTypeMasterReducer,
  serviceRequestNumberMasterState: ServiceRequestNumberMasterReducer,
  saveAttachLetterState: SaveAttachLetter,
  NPPESDataState: NppesDetailsDataReducer,
  orderingNPPESListState: NppesOrderingDetailsListReducer,
  primaryNPPESListState: NppesPrimaryDetailsListReducer,
  referralMgmtSystemState: ReferralManagementSystem,
  serviceRequestDisciplinesState: serviceRequestDisciplines,
  storeFilterData: StoreFilterDataReducer,
  facilityTypeState: FacilityTypeMasterReducer,
  resendFaxState: ResendFaxReducer,
  resendEmailState: ResendEmailReducer,
  keepNoteOpenState: KeepNoteOpen,
  keepNoteOpenUpdateState: KeepNoteOpenUpdate,
  referralNoteUserListState: ReferralNoteUserListReducer,
  woundCareState: WoundCareReducer,
  rationaleTemplateState: RationaleTemplateReducer,
  denialRationaleListState: DenialRationaleListReducer,
  DownLoadNotesState: DownLoadNotesReducer,
  DownLoadDisciplineNotesState: DownDisciplineLoadNotesReducer,
  rationaleManagementNameState: RationaleManagementNameReducer,
  woundCareDisciplineState: WoundCareDisciplineReducer,
  userModifiedState: UserModifiedReducer,
  masterSyncState: MasterSyncReducer,
  priorAuthReceivedMethodState: PriorAuthReceivedMethodResponse,
  documentSourceForFilterState: DocumentSourceForFilterReducer,
  putServiceProviderDetailsState: PutServiceProviderDetailsReducer,
  getApprovedVisitsState: ApprovedVisitsReducer,
  putRationaleTemplateState: PutRationaleTemplateReducer,
  postRationaleTemplateState: PostRationaleTemplateReducer,
  documentNoteUserListState: DocumentNoteUserListReducer,
  getNotesTemplateTypeState: NotesTemplateTypeReducer,
  ValidatePatientInfoState: ValidatePatientSubscriberIdInfo,
  ValidatePatientMbiInfoState: ValidatePatientMbiInfo,
  relationshipTypeState: RelationshipTypeMasterReducer,
  serviceRequestIsRetroState: ServiceRequestIsRetroReducer,
  maxAllowedSocDateState: MaxAllowedSocDateReducer,
  serviceStatusMasterState: ServiceStatusMasterReducer,
  sendEmailState: SendEmailReducer,
  appConfigVariableState: AppConfigsVariableReducer,
});

export default createRootReducer;
